export default __webpack_public_path__ + "static/media/35.6b58e026.png";